<div class="padding">
    <h1 class="left-box">{{ 'reporting.reporting' | transloco }}</h1>

    <div class="table-container">
        <mat-tab-group animationDuration="0ms" [selectedIndex]="_selectedIndex">
            <mat-tab [label]="'common.labels.liveReports' | transloco">
                <app-report-templates-list></app-report-templates-list>
            </mat-tab>
            <mat-tab [label]="'common.labels.savedReports' | transloco">
                <mat-card>
                    <mat-card-content>
                        <app-requested-reports-list></app-requested-reports-list>
                    </mat-card-content>
                </mat-card>
            </mat-tab>
            <!-- <mat-tab label="Schedule Reports">
                Coming Soon!
            </mat-tab> -->
        </mat-tab-group>
    </div>
</div>
